import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { useLocation, useNavigate, useParams } from "react-router-dom";



function AddItemPage() {
    const [cargando, setCargando] = useState(false);
    const [descripcion, setDescripcion] = useState('');
    const [activoStatus, setActivoStatus] = useState(false);
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingGuardar, setLoadingGuardar] = useState(false);
    const [editable, setEditable] = useState(false);

    const params = useParams();
    const localizacion = useLocation();
    // console.log("params", localizacion);

    const navigate = useNavigate();



    useEffect(() => {
        // handleListarProductos();
        setTimeout(() => {
            setCargando(true);

            if (params?.id) {
                setEditable(true);
                setDescripcion(localizacion?.state?.data?.name);
                // setActivoStatus(true);
            } else {
                setEditable(false);
                setDescripcion('');
                // setActivoStatus(false);
            }
        }, 1000);
    }, [params]);




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };

    //=========================================================funcion para cancelar y volver a la lista
    const handleCancelar = () => {
        window.history.back();
    };

    //=========================================================funcion para guardar
    const handleGuardar = () => {
        let body = {};
        body.nombre = descripcion;
        body.status = activoStatus ? "Activo" : "Inactivo";

        console.log("body", body);

        //validar campos que no esten vacios
        if (descripcion.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('Todos los campos son obligatorios');
        } else {

            setLoadingGuardar(true);


            setTimeout(() => {
                setLoadingGuardar(false);

                setTimeout(() => {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje('Guardado con exito');

                    setTimeout(() => {
                        navigate('/app/admin/atc/itmes');
                    }, 1000);
                }, 1000);

            }, 2000);
        }
    };





    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="mx-auto max-w-4xl">
                    {cargando ? (
                        <div className="rounded-xl bg-white p-6 shadow-xl">
                            <div className="mb-6">
                                <h1 className="mb-1 text-2xl font-bold text-gray-800">
                                    {editable ? 'Editar Item' : 'Crear Item'}
                                </h1>
                                <p className="text-sm text-gray-500">
                                    Completa la información principal del item.
                                </p>
                            </div>

                            <div className="grid grid-cols-1 gap-5">
                                <div>
                                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Descripción</label>
                                    <input
                                        type="text"
                                        value={descripcion}
                                        onChange={(e) => setDescripcion(e.target.value)}
                                        autoCapitalize="none"
                                        autoCorrect="off"
                                        placeholder="Escribe la descripción"
                                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2.5 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                                    />
                                </div>

                                <label className="inline-flex items-center gap-2 text-sm text-gray-700">
                                    <input
                                        type="checkbox"
                                        checked={activoStatus}
                                        onChange={(e) => setActivoStatus(e.target.checked)}
                                        className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                    />
                                    Con devolución?
                                </label>

                                <div className="mt-2 flex flex-wrap items-center gap-4 border-t border-gray-200 pt-5">
                                    <button
                                        type="button"
                                        onClick={handleGuardar}
                                        className="rounded-lg bg-[#104063] px-6 py-2 font-medium text-white transition-colors hover:bg-[#0d3553]"
                                    >
                                        Guardar
                                    </button>

                                    <button
                                        type="button"
                                        onClick={handleCancelar}
                                        className="rounded-lg bg-gray-100 px-6 py-2 font-medium text-gray-700 transition-colors hover:bg-gray-200"
                                    >
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="bg-white rounded-xl shadow-md p-8">
                            <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                            <div className="space-y-4">
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                <div className="h-24 bg-gray-200 rounded animate-pulse" />
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Backdrop open={loadingGuardar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default AddItemPage;